import { FullInformationBar } from './FullInformationBar';

export const FullBarManager = ({ onClick }: { onClick: () => void }) => {
  return (
    <FullInformationBar
      onClick={onClick}
      title="Are You a Property Manager?"
      message="If you manage 5 or more properties, please contact the alluraDirect sales team before starting. Resources are available to help integrate and onboard bulk listings."
      buttonText="Contact Sales"
    />
  );
};
